/* ==========================================================================
   DUNE · Спробуй образ (sections/dune-try-look.liquid)
   Лента моделей по кругу («Подіум»): модель в центре крупная, соседи меньше,
   бледнее и размыты. Страница прокручивается как обычно, лента двигается
   только вбок: перетаскивание и свайп (лента идёт за пальцем, бросок
   докатывает на несколько образов), горизонтальный жест трекпада
   (или колесо с Shift), стрелки, клик по модели, клавиши ←/→.
   После жеста лента доезжает и встаёт ровно на образ.
   Справа состав активного образа; «весь образ у кошик» уходит одним
   запросом /cart/add.js, после него тема обновляет счётчик и открывает корзину.
   ========================================================================== */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };
  var mod = function (x, m) { return ((x % m) + m) % m; };

  function init(root) {
    if (root.__duneTl) root.__duneTl.destroy();

    var stage = root.querySelector('[data-tl-stage]');
    var world = root.querySelector('[data-tl-world]');
    var progress = root.querySelector('[data-tl-progress]');
    var looks = [].slice.call(root.querySelectorAll('[data-tl-look]'));
    var dots = [].slice.call(root.querySelectorAll('[data-tl-dot]'));
    var originals = [].slice.call(world.querySelectorAll('[data-tl-fig]'));
    var N = originals.length;
    if (!N) return;

    // Лента повторяет образы, пока в ней не будет хотя бы 7 фигур:
    // фигура перескакивает с края на край, только когда её не видно.
    var M = N > 1 ? N * Math.ceil(7 / N) : 1;
    var figs = originals.slice();
    for (var c = N; c < M; c++) {
      var clone = originals[c % N].cloneNode(true);
      clone.removeAttribute('data-shopify-editor-block');
      clone.setAttribute('aria-hidden', 'true');
      clone.tabIndex = -1;
      world.appendChild(clone);
      figs.push(clone);
    }
    var wrap = function (x) { return mod(x + M / 2, M) - M / 2; };

    var target = 0, cur = 0, gapPx = 300;
    var active = -1, activeFig = -1, W = 0, H = 0, raf = 0, visible = true, held = false;
    var chosen = looks.map(function () { return {}; });

    function measure() {
      W = stage.clientWidth;
      H = stage.clientHeight;
    }

    function snap(n) {
      target = Math.round(n);
      kick();
    }
    function step(n) {
      if (!n || N < 2) return;
      snap(Math.round(target) + n);
    }

    function place(f, d) {
      var a = Math.abs(d), s = d < 0 ? -1 : 1;
      if (!f.__ratio) f.__ratio = parseFloat(getComputedStyle(f).getPropertyValue('--tl-ratio')) || 0.32;
      var fw = H * 0.86 * f.__ratio;
      var gap = Math.max(fw * 0.95, Math.min(W * 0.2, H * 0.36));
      gapPx = gap * 1.08;
      var tx = s * (a <= 1 ? a * gap * 1.08 : gap * 1.08 + (a - 1) * gap * 0.84);
      var sc = 1 - Math.min(a, 3) * 0.12;
      var op = a < 2.2 ? 1 : Math.max(0, 1 - (a - 2.2) * 1.7);
      var bl = reduced ? 0 : Math.max(0, a - 0.6) * 0.9;
      var sat = 1 - Math.min(a, 1) * 0.35;
      f.style.transform = 'translate3d(calc(-50% + ' + tx.toFixed(1) + 'px), 0, 0) scale(' + sc.toFixed(4) + ')';
      f.style.opacity = op.toFixed(3);
      f.style.filter = (bl > 0.05 ? 'blur(' + bl.toFixed(2) + 'px) ' : '') + 'saturate(' + sat.toFixed(3) + ')';
      f.style.zIndex = 100 - Math.round(a * 10);
      f.style.visibility = op < 0.01 ? 'hidden' : 'visible';
    }

    function frame() {
      raf = 0;
      // под пальцем лента идёт без задержки, после — плавно доезжает до образа
      if (held || reduced) cur = target;
      else cur += (target - cur) * 0.085;
      if (Math.abs(target - cur) < 0.0005) cur = target;
      for (var j = 0; j < M; j++) place(figs[j], wrap(j - cur));
      if (progress) progress.style.width = (N > 1 ? Math.min(1, mod(cur, N) / (N - 1)) * 100 : 100) + '%';
      var af = mod(Math.round(cur), M);
      if (af !== activeFig) {
        activeFig = af;
        figs.forEach(function (f, j) { f.classList.toggle('is-active', j === af); });
      }
      var a = af % N;
      if (a !== active) setActive(a);
      if (cur !== target && visible) raf = requestAnimationFrame(frame);
    }
    function kick() { if (!raf && visible) raf = requestAnimationFrame(frame); }

    function setActive(a) {
      active = a;
      looks.forEach(function (l, i) {
        l.hidden = i !== a;
        l.classList.toggle('is-on', i === a);
      });
      dots.forEach(function (d, i) { d.classList.toggle('is-on', i === a); });
      var n = root.querySelector('[data-tl-n]');
      var name = root.querySelector('[data-tl-name]');
      if (n) n.textContent = pad(a + 1);
      if (name && looks[a]) name.textContent = looks[a].getAttribute('data-name');
      msg('', false);
    }

    var fromSpot = false;
    function hot(k, on) {
      var f = figs[activeFig];
      if (f) [].forEach.call(f.querySelectorAll('[data-tl-spot]'), function (s) {
        s.classList.toggle('is-hot', on && s.getAttribute('data-tl-spot') === k);
      });
      var look = looks[active];
      if (!look) return;
      var list = look.querySelector('[data-tl-list]');
      var row = null;
      [].forEach.call(look.querySelectorAll('[data-tl-item]'), function (li) {
        var is = on && li.getAttribute('data-tl-item') === k;
        li.classList.toggle('is-hot', is);
        if (is) row = li;
      });
      if (list) list.classList.toggle('has-hot', !!row);
      if (row && fromSpot) reveal(list, row);
    }

    // докрутить список состава до строки, не трогая прокрутку страницы
    function reveal(list, row) {
      if (!list) return;
      var b = reduced ? 'auto' : 'smooth';
      if (list.scrollWidth > list.clientWidth + 1) {
        var x = row.offsetLeft - list.offsetLeft;
        if (x < list.scrollLeft || x + row.offsetWidth > list.scrollLeft + list.clientWidth) list.scrollTo({ left: x, behavior: b });
      } else if (list.scrollHeight > list.clientHeight + 1) {
        var y = row.offsetTop - list.offsetTop;
        if (y < list.scrollTop || y + row.offsetHeight > list.scrollTop + list.clientHeight) list.scrollTo({ top: y - 8, behavior: b });
      }
    }

    function msg(text, ok) {
      var m = root.querySelector('[data-tl-msg]');
      if (!m) return;
      m.textContent = text;
      m.classList.toggle('is-ok', !!ok);
    }

    // --- события ---------------------------------------------------------

    var off = [];
    function on(el, type, fn, opts) { el.addEventListener(type, fn, opts); off.push(function () { el.removeEventListener(type, fn, opts); }); }

    var prev = root.querySelector('[data-tl-prev]');
    var next = root.querySelector('[data-tl-next]');
    if (prev) on(prev, 'click', function () { step(-1); });
    if (next) on(next, 'click', function () { step(1); });

    var dragged = false, hotT = 0;
    on(world, 'click', function (e) {
      var spot = e.target.closest('[data-tl-spot]');
      var fig = e.target.closest('[data-tl-fig]');
      if (!fig || dragged) return;
      if (spot && fig.classList.contains('is-active')) {
        // на телефоне наведения нет: касание подсвечивает вещь на пару секунд
        var k = spot.getAttribute('data-tl-spot');
        fromSpot = true; hot(k, true); fromSpot = false;
        clearTimeout(hotT);
        if (e.pointerType !== 'mouse') hotT = setTimeout(function () { hot(k, false); }, 2200);
        return;
      }
      step(Math.round(wrap(figs.indexOf(fig) - cur)));
    });
    on(world, 'keydown', function (e) {
      var fig = e.target.closest('[data-tl-fig]');
      if (!fig || (e.key !== 'Enter' && e.key !== ' ')) return;
      e.preventDefault();
      step(Math.round(wrap(figs.indexOf(fig) - cur)));
    });
    on(world, 'mouseover', function (e) {
      var s = e.target.closest('[data-tl-spot]');
      if (s) { fromSpot = true; hot(s.getAttribute('data-tl-spot'), true); fromSpot = false; }
    });
    on(world, 'mouseout', function (e) {
      var s = e.target.closest('[data-tl-spot]');
      if (s && !s.contains(e.relatedTarget)) hot(s.getAttribute('data-tl-spot'), false);
    });

    var panel = root.querySelector('.dune-tl__panel');
    on(panel, 'mouseover', function (e) {
      var li = e.target.closest('[data-tl-item]');
      if (li) hot(li.getAttribute('data-tl-item'), true);
    });
    on(panel, 'mouseout', function (e) {
      var li = e.target.closest('[data-tl-item]');
      if (li && !li.contains(e.relatedTarget)) hot(li.getAttribute('data-tl-item'), false);
    });
    on(panel, 'click', function (e) {
      var b = e.target.closest('[data-tl-size]');
      if (b) {
        var li = b.closest('[data-tl-item]');
        chosen[active][li.getAttribute('data-tl-item')] = b.getAttribute('data-tl-size');
        [].forEach.call(li.querySelectorAll('[data-tl-size]'), function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        li.classList.remove('is-missing');
        return;
      }
      if (e.target.closest('[data-tl-buy]')) buy(e.target.closest('[data-tl-buy]'));
    });

    // перетаскивание и свайп: лента идёт за пальцем, бросок докатывает дальше
    // шаг жеста: не меньше трети сцены, иначе на телефоне короткий свайп пролистывает несколько образов
    var px = null, py = 0, base = 0, axis = '', track = [], unit = 300, moved = 0;
    on(stage, 'pointerdown', function (e) {
      if (N < 2 || (e.pointerType === 'mouse' && e.button !== 0)) return;
      px = e.clientX; py = e.clientY; base = cur; axis = ''; track = [[e.timeStamp, e.clientX]];
      unit = Math.max(gapPx, W * 0.38); moved = 0;
      dragged = false;
    });
    on(stage, 'pointermove', function (e) {
      if (px === null) return;
      var dx = e.clientX - px, dy = e.clientY - py;
      if (!axis) {
        if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
        axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        if (axis === 'y') { px = null; return; }
        held = true; dragged = true;
        root.classList.add('is-dragging');
        try { stage.setPointerCapture(e.pointerId); } catch (err) {}
      }
      moved = dx;
      target = base - dx / unit;
      track.push([e.timeStamp, e.clientX]);
      if (track.length > 6) track.shift();
      kick();
    });
    function release() {
      if (px === null) return;
      px = null;
      if (!held) return;
      held = false;
      root.classList.remove('is-dragging');
      var a = track[0], b = track[track.length - 1];
      var v = b && a && b[0] > a[0] ? (b[1] - a[1]) / (b[0] - a[0]) : 0; // px за мс
      // бросок докатывает по скорости, но не дальше трёх образов от начала жеста;
      // заметный жест всегда сдвигает хотя бы на один образ
      var from = Math.round(base);
      var n = Math.round(target - (v * 160) / unit);
      if (n === from && Math.abs(moved) > 36) n = from + (moved < 0 ? 1 : -1);
      snap(Math.max(from - 3, Math.min(from + 3, n)));
      setTimeout(function () { dragged = false; }, 0);
    }
    on(stage, 'pointerup', release);
    on(stage, 'pointercancel', release);

    // горизонтальный жест трекпада и колесо с Shift
    var wheelT = 0;
    on(stage, 'wheel', function (e) {
      if (N < 2) return;
      var dx = e.deltaX, dy = e.deltaY;
      if (e.shiftKey && !dx) dx = dy;
      else if (Math.abs(dx) <= Math.abs(dy)) return;
      e.preventDefault();
      var unit = e.deltaMode === 1 ? 32 : e.deltaMode === 2 ? W : 1;
      target += (dx * unit) / (gapPx * 1.6);
      kick();
      clearTimeout(wheelT);
      wheelT = setTimeout(function () { snap(target); }, 140);
    }, { passive: false });

    on(window, 'keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      if (/input|textarea|select/i.test(document.activeElement && document.activeElement.tagName)) return;
      var r = stage.getBoundingClientRect();
      if (r.top > innerHeight * 0.6 || r.bottom < innerHeight * 0.4) return;
      step(e.key === 'ArrowRight' ? 1 : -1);
    });

    on(window, 'resize', function () { measure(); kick(); });

    // вне экрана анимация не крутится
    var io = new IntersectionObserver(function (entries) {
      visible = entries[0].isIntersecting;
      if (visible) kick();
    });
    io.observe(root);

    // в редакторе: выбранный блок встаёт в центр
    on(document, 'shopify:block:select', function (e) {
      var i = originals.indexOf(e.target);
      if (i < 0) return;
      snap(target + Math.round(wrap(i - target)));
    });

    // --- весь образ у кошик ------------------------------------------------

    function buy(btn) {
      var look = looks[active];
      if (!look || btn.getAttribute('aria-busy') === 'true') return;
      var items = [], missing = [];
      [].forEach.call(look.querySelectorAll('[data-tl-item]'), function (li) {
        var k = li.getAttribute('data-tl-item');
        var one = li.querySelector('[data-tl-one]');
        if (li.querySelector('[data-tl-out]')) return;
        var id = one ? one.getAttribute('data-tl-one') : chosen[active][k];
        li.classList.toggle('is-missing', !id);
        if (id) items.push({ id: Number(id), quantity: 1 });
        else missing.push(li);
      });
      if (missing.length) {
        msg(root.getAttribute('data-missing') + ' ' + missing.map(function (li) { return li.getAttribute('data-type'); }).join(', ') + '.', false);
        missing[0].scrollIntoView({ block: 'nearest', inline: 'start', behavior: reduced ? 'auto' : 'smooth' });
        return;
      }
      if (!items.length) return;
      btn.setAttribute('aria-busy', 'true');
      var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(base + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          btn.removeAttribute('aria-busy');
          if (!res.ok) {
            msg(res.j.description || res.j.message || 'Не вдалося додати образ.', false);
            return;
          }
          msg(root.getAttribute('data-added') + ': ' + items.length + '.', true);
          // тема обновляет счётчик и панель корзины по этому событию, кнопка корзины открывает панель
          document.dispatchEvent(new CustomEvent('apps:product-added-to-cart', { bubbles: true }));
          var icons = [].slice.call(document.querySelectorAll('[data-js-cart-icon]'));
          var icon = icons.filter(function (x) { return x.offsetParent !== null; })[0];
          if (icon && document.querySelector('.quick-cart')) setTimeout(function () { icon.click(); }, 350);
        })
        .catch(function () {
          btn.removeAttribute('aria-busy');
          msg('Не вдалося додати образ. Спробуйте ще раз.', false);
        });
    }

    measure();
    window.addEventListener('load', function () { measure(); kick(); }, { once: true });
    frame();

    root.__duneTl = {
      destroy: function () {
        off.forEach(function (f) { f(); });
        io.disconnect();
        clearTimeout(wheelT);
        if (raf) cancelAnimationFrame(raf);
        figs.slice(N).forEach(function (f) { f.remove(); });
        root.__duneTl = null;
      }
    };
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-dune-tl]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    [].forEach.call(e.target.querySelectorAll('[data-dune-tl]'), function (r) { if (r.__duneTl) r.__duneTl.destroy(); });
  });
})();
